/**
 * DWV Provider
 * Plataforma de networking imobiliário
 */

import type { DatabaseProvider } from '../types';

export const dwvProvider: DatabaseProvider = {
  id: 'database-dwv',
  name: 'DWV',
  description: 'Plataforma de networking imobiliário',
  type: 'properties',
  color: '#10b981', // emerald-500
  icon: 'home',
  authFields: [
    {
      name: 'apiToken',
      type: 'text',
      label: 'Token de API *',
      placeholder: 'Cole aqui seu token de API da DWV',
      required: true,
      helpText: 'Você pode encontrar seu token de API nas configurações da sua conta DWV',
    },
  ],
  isAvailable: true,
};
